<template>
  <div id="apply">
    <cube-form :model="model" @submit="submitHandler" @validate="validateHandler">
      <cube-form-group legend="检车站信息填写">
        <cube-form-item :field="fields[0]"></cube-form-item>
        <cube-form-item :field="fields[1]" :class="{ 'active' : model.cityName}">
          <cube-button @click="showCityPicker('所在盟市')">{{ model.cityName || '请选择所在盟市' }}</cube-button>
        </cube-form-item>
        <cube-form-item :field="fields[2]"></cube-form-item>
        <cube-form-item :field="fields[3]" :class="{ 'active' : model.createStationDate}">
          <cube-button @click="showDatePicker('成立日期')">{{ model.createStationDate || '请输入成立日期' }}</cube-button>
        </cube-form-item>
        <cube-form-item :field="fields[4]" :class="{ 'active' : model.dsType}">
          <cube-button @click="showDsTypePicker('企业性质')">{{ model.dsType ? dsTypeMap[model.dsType] : '请输入企业性质' }}</cube-button>
        </cube-form-item>
        <cube-form-item :field="fields[5]">
          <cube-input v-model="model.orgnumber" placeholder="请输入信用代码">
            <div slot="append" style="margin-left:15px; color: orange">
              <span @click="showExample(0)">示例</span>
            </div>
          </cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[6]"></cube-form-item>
        <cube-form-item :field="fields[7]">
          <cube-input v-model="model.ma" placeholder="请输入证书编号">
            <div slot="append" style="margin-left:15px; color: orange">
              <span @click="showExample(1)">示例</span>
            </div>
          </cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[8]" :class="{ 'active' : model.maExpDate }">
          <div style="display: flex;justify-content: space-between">
            <cube-button @click="showMADatePicker('证书到期日期')" style="width: 90%">
            {{ model.maExpDate || '请输入证书到期日期' }}
            </cube-button>
            <div @click="showExample(2)" style="min-width:46px;text-align: right;line-height:46px;color:orange">示例</div>
          </div>
        </cube-form-item>
        <cube-form-item :field="fields[9]">
          <cube-input v-model="model.staffNumber" type="number" placeholder="请输入人员数量"></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[10]">
          <cube-input v-model="model.detectCapYear" type="number" placeholder="请输入年检测能力"></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[11]">
          <cube-input v-model="model.detectCapMonth" type="number" placeholder="请输入月检测能力"></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[12]">
          <cube-input v-model="model.detectCapDay" type="number" placeholder="请输入日检测能力"></cube-input>
        </cube-form-item>
      </cube-form-group>
      <cube-form-group legend="联系信息填写">
        <cube-form-item :field="fields[13]"></cube-form-item>
        <cube-form-item :field="fields[14]">
          <cube-input v-model="model.contactPhone" type="tel" placeholder="请输入负责人联系电话"></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[15]"></cube-form-item>
        <cube-form-item :field="fields[16]">
          <cube-input v-model="model.operatorPhone" type="tel" placeholder="请输入操作员联系电话"></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[17]"></cube-form-item>
        <cube-form-item :field="fields[18]">
          <cube-input v-model="model.accountantPhone" type="tel" placeholder="请输入财务联系电话"></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[19]"></cube-form-item>
        <cube-form-item :field="fields[20]">
          <cube-input v-model="model.technicianPhone" type="tel" placeholder="请输入技术员联系电话"></cube-input>
        </cube-form-item>
      </cube-form-group>
      <cube-form-group>
        <cube-button type="submit" @click="submitHandler">提交</cube-button>
      </cube-form-group>
    </cube-form>
  </div>
</template>

<script>
import Moment from 'moment'
import {applyMerchant, queryApplicationsByOpenId} from '../modules/services/basic-service'

const dsTypeList = [
  {value:"100",text: "内资"},
  {value:"110",text: "国有全资"},
  {value:"120",text: "集体全资"},
  {value:"130",text: "股份合作"},
  {value:"140",text: "联 营"},
  {value:"141",text: "国有联营"},
  {value:"142",text: "集体联营"},
  {value:"143",text: "国有与集体联营"},
  {value:"149",text: "其他联营"},
  {value:"150",text: "有限责任(公司)"},
  {value:"159",text: "其他有限责任(公司)"},
  {value:"160",text: "股份有限(公司)"},
  {value:"170",text: "私有"},
  {value:"171",text: "私有独资"},
  {value:"172",text: "私有合伙"},
  {value:"173",text: "私营有限责任(公司)"},
  {value:"174",text: "私营股份有限(公司)"},
  {value:"175",text: "个体经营"},
  {value:"179",text: "其他私有"},
  {value:"190",text: "其他内资"},
  {value:"900",text: "其 他"}
]
const cityNameList = [
  {text: "阿拉善盟"},
  {text: "兴安盟"},
  {text: "乌兰察布市"},
  {text: "巴彦淖尔市"},
  {text: "呼伦贝尔市"},
  {text: "鄂尔多斯市"},
  {text: "通辽市"},
  {text: "赤峰市"},
  {text: "乌海市"},
  {text: "包头市"},
  {text: "呼和浩特市"},
  {text: "锡林浩特市"},
  {text: "满州里市"},
  {text: "二连浩特市"},
  {text: "锡林郭勒盟"}
]
export default {
  name: 'apply',
  components: {
  },
  data () {
    return {
      dsTypeMap: {
        100: "内资",
        110: "国有全资",
        120: "集体全资",
        130: "股份合作",
        140: "联 营",
        141: "国有联营",
        142: "集体联营",
        143: "国有与集体联营",
        149: "其他联营",
        150: "有限责任(公司)",
        159: "其他有限责任(公司)",
        160: "股份有限(公司)",
        170: "私有",
        171: "私有独资",
        172: "私有合伙",
        173: "私营有限责任(公司)",
        174: "私营股份有限(公司)",
        175: "个体经营",
        179: "其他私有",
        190: "其他内资",
        900: "其 他"
      },
      model: {
        orgId: '150000',
        merchantName: '',
        createStationDate: '',
        merchantAddress: '',
        dsType: '',
        dsTypeName: '',
        cityName: '',
        ma: '',
        maExpDate: '',
        email: '',
        orgnumber: '',
        staffNumber: '',
        detectCapYear: '',
        detectCapMonth: '',
        detectCapDay: '',
        contactName: '',
        contactPhone: '',
        operator: '',
        operatorPhone: '',
        accountant: '',
        accountantPhone: '',
        technician: '',
        technicianPhone: '',
        applicant:  ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'merchantName',
          label: '机构名称',
          props: {
            placeholder: '请输入机构名称'
          },
          rules: {
            required: true
          }
        },
        {
          modelKey: 'cityName',
          label: '所在盟市',
          rules: {
            required: true
          }
        },
        {
          type: 'textarea',
          modelKey: 'merchantAddress',
          label: '经营地址',
          props: {
            placeholder: '请输入经营地址'
          },
          rules: {
            required: true
          }
        },
        {
          modelKey: 'createStationDate',
          label: '成立日期',
          rules: {
            required: true
          }
        },
        {
          modelKey: 'dsType',
          label: '企业性质',
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'orgnumber',
          label: '统一社会信息代码',
          props: {
            placeholder: '请输入统一社会信用代码'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'email',
          label: '企业邮箱',
          props: {
            placeholder: '请输入企业邮箱'
          }
        },
        {
          type: 'input',
          modelKey: 'ma',
          label: '标定/标准证书编号',
          props: {
            placeholder: '请输入标定/标准证书编号'
          }
        },
        {
          modelKey: 'maExpDate',
          label: '标定/标准证书到期日期'
        },
        {
          modelKey: 'staffNumber',
          label: '人员数量'
        },
        {
          modelKey: 'detectCapYear',
          label: '机构年检测能力'
        },
        {
          modelKey: 'detectCapMonth',
          label: '机构月检测能力'
        },
        {
          modelKey: 'detectCapDay',
          label: '机构日检测能力'
        },
        {
          type: 'input',
          modelKey: 'contactName',
          label: '负责人',
          props: {
            placeholder: '请输入负责人姓名'
          },
          rules: {
            required: true
          }
        },
        {
          modelKey: 'contactPhone',
          label: '负责人联系电话',
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'operator',
          label: '操作员',
          props: {
            placeholder: '请输入操作员姓名'
          }
        },
        {
          label: '操作员联系电话'
        },
        {
          type: 'input',
          modelKey: 'accountant',
          label: '财务',
          props: {
            placeholder: '请输入财务姓名'
          }
        },
        {
          label: '财务联系电话'
        },
        {
          type: 'input',
          modelKey: 'technician',
          label: '技术员',
          props: {
            placeholder: '请输入技术员姓名'
          }
        },
        {
          label: '技术员联系电话'
        }
      ],
      examples: [
        require('../assets/example1.png'),
        require('../assets/example2.jpg'),
        require('../assets/example3.png')
      ]
    }
  },
  created () {
    if (!this.$route.query.openId) {
      this.$router.push({
        path: '/authorize-fail?reason=未获取到微信用户ID'
      })
    } else {
      const self = this
      queryApplicationsByOpenId(this.$route.query.openId).then(({body}) => {
        if (body) {
          self.model = body
          self.model.dsTypeName = self.dsTypeMap[self.model.dsType]
        }
      })
    }
    this.model.applicant = this.$route.query.openId
  },
  methods: {
    showExample (index) {
      this.$createImagePreview({
        imgs: [this.examples[index]]
      }).show()
    },
    showDatePicker (title) {
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: title,
          min: new Date(1990, 1, 1),
          max: new Date(),
          value: new Date(),
          onSelect: this.dateSelectHandler
        })
      }
      this.datePicker.show()
    },
    showCityPicker (title) {
      if (!this.cityPicker) {
        this.cityPicker = this.$createPicker({
          title: title,
          data: [cityNameList],
          onSelect: this.citySelectHandler
        })
      }
      this.cityPicker.show()
    },
    citySelectHandler (selectedVal, selectedIndex, selectedText) {
      this.model.cityName = selectedText[0]
    },
    showDsTypePicker (title) {
      if (!this.dsTypePicker) {
        this.dsTypePicker = this.$createPicker({
          title: title,
          data: [dsTypeList],
          onSelect: this.dsTypeSelectHandler
        })
      }
      this.dsTypePicker.show()
    },
    dateSelectHandler (date) {
      this.model.createStationDate = Moment(date).format('YYYY-MM-DD')
    },
    dsTypeSelectHandler (selectedVal, selectedIndex, selectedText) {
      this.model.dsType = selectedVal[0]
      this.model.dsTypeName = selectedText[0]
    },
    showMADatePicker (title) {
      if (!this.maDatePicker) {
        this.maDatePicker = this.$createDatePicker({
          title: title,
          min: new Date(),
          max: Moment().add(10, 'y').toDate(),
          value: Moment().add(1, 'y').toDate(),
          onSelect: this.maDateSelectHandler
        })
      }
      this.maDatePicker.show()
    },
    maDateSelectHandler (date) {
      this.model.maExpDate = Moment(date).format('YYYY-MM-DD')
    },
    submitHandler () {
      applyMerchant(this.model).then(({body}) => {
        if (body) {
          this.$router.push({
            path: 'apply-result?openId=' + this.model.applicant
          })
        }
      })
      return false
    },
    validateHandler () {
    }
  }
}
</script>

<style lang="stylus" scoped>
  #apply {
    .cube-form-item {
    }
  }
</style>
<style lang="stylus">
  #apply {
    .cube-form-group-legend {
      padding: 10px
    }
    .cube-form_standard .cube-form-label {
      width: 120px
    }
    .cube-form-field {
      .cube-input input {
        text-align right
      }
      button {
        padding-left: 0;
        padding-right: 0;
        color: inherit;
        background: none;
        border: none;
        text-align right
        font-size: 14px;
        color: #ccc
      }
      .cube-textarea-wrapper textarea{
        font-size 14px
        text-align right
        font-family Arial
      }
      .cube-textarea-wrapper.cube-textarea_expanded textarea {
        text-align right
      }
      .cube-textarea-wrapper.cube-textarea_active textarea {
        text-align left
      }
    }
    .cube-form-item.active {
      .cube-form-field {
        button {
          color: #666;
        }
      }
    }
    .cube-form-item_required .cube-form-label:before {
      content: none
    }
  }
</style>
